import { tours } from "./tours";

export const getTour = ( id ) => {
    return tours.find( tour => tour.id === id );
}